
export const Constants = {
    storageKeys: {
        authUser: "auth-user",
        campaign: "act-cpgn",
    },
    colors: {
        primary: "#4f46e5",
    },
    plugin_url: "https://chrome.google.com/webstore/devconsole/eacf3445-0406-45c6-8200-07354a856c60/hnaijhnhaokhjipceaflmjimffoieiee/edit/status",
    terms_url: "https://drive.google.com/file/d/1roN1jW9c49x9u8uXDOOFYae5Tdgrvyno/view?usp=sharing",
};
